import { Moment } from 'moment';
import React from 'react';
import { connect } from 'react-redux';

import { AppState } from 'src/config/appState';
import { StepButtons } from 'src/modules/programs/components/StepButtons';
import * as S from 'src/modules/programs/stepComponents/styles';

import {
    changeActionActivities,
    changeActionActivityData,
    submitActivitiesData,
} from '../actions/weekThreeActions';
import { ActivitiesSelectionDomainTab } from '../components/ActivitiesSelectionDomainTab';
import { ActivitiesSelectionDomain, PlannedActivity } from '../models/weekThree';
import {
    getPlannedActivities,
    getSelectedDomains,
    isActionsSelectionDataValid,
} from '../selectors/weekThreeSelectors';

interface StateProps {
    selectedDomains: ActivitiesSelectionDomain[];
    isDataValid: boolean;
    chosenActivites: PlannedActivity[];
}

interface ActionsProps {
    changeActionActivities: typeof changeActionActivities;
    submitActivitiesData: typeof submitActivitiesData;
    changeActionActivityData: typeof changeActionActivityData;
}

interface Props extends StateProps, ActionsProps {
    goToPreviousStep: () => void;
    goToNextStep: () => void;
}

export class ChoosingValuedActionStepContainer extends React.Component<Props> {
    private handleActivityChange = (domainTitle: string, description: string) => {
        return this.props.changeActionActivities({ domainTitle, description });
    };

    private handleAreaInputChange = (
        domainTitle: string,
        description: string,
        value: Moment,
        field: string,
    ) => {
        return this.props.changeActionActivityData({
            domainTitle,
            description,
            value,
            field,
        });
    };

    private handleSubmit = () => {
        if (!this.props.isDataValid) {
            return;
        }

        this.props.submitActivitiesData(this.props.chosenActivites);
        this.props.goToNextStep();
    };

    public render(): JSX.Element {
        const { selectedDomains } = this.props;

        return (
            <>
                <S.ContentRow>
                    <S.ContentColumn>
                        <S.StepHeading small>Values into actions:</S.StepHeading>
                        <S.StepHeading>Choosing a Valued Action</S.StepHeading>
                        <S.StepDescription small>
                            What things do you want to do to live according to your values this
                            week? Make sure you pick an action that is achievable.
                        </S.StepDescription>
                    </S.ContentColumn>
                </S.ContentRow>
                <S.StyledTabs>
                    {selectedDomains.map(domain => (
                        <S.TabPane key={domain.title} tab={`${domain.title}`}>
                            <S.TabPaneContent>
                                <ActivitiesSelectionDomainTab
                                    selectedDomain={domain}
                                    activities={domain.activities.map(
                                        activity => activity.description,
                                    )}
                                    onActivityChange={this.handleActivityChange}
                                    onInputChange={this.handleAreaInputChange}
                                />
                            </S.TabPaneContent>
                        </S.TabPane>
                    ))}
                </S.StyledTabs>
                <StepButtons
                    onPreviousClick={this.props.goToPreviousStep}
                    onNextClick={this.handleSubmit}
                    nextDisabled={!this.props.isDataValid}
                    hasNextStep
                />
            </>
        );
    }
}

const mapStateToProps = (state: AppState): StateProps => ({
    chosenActivites: getPlannedActivities(state),
    selectedDomains: getSelectedDomains(state),
    isDataValid: isActionsSelectionDataValid(state),
});

export const ChoosingValuedActionStep = connect(mapStateToProps, {
    changeActionActivityData,
    changeActionActivities,
    submitActivitiesData,
})(ChoosingValuedActionStepContainer);
